import logo from './images/tb-logo.png';
import { Outlet } from 'react-router';
import React from "react";
import muiTheme from './theme/muiTheme';
import * as theme from './theme';
import './theme/index.css';
import { ThemeProvider } from '@mui/material';

function VideoLayout() {

  return (
    <ThemeProvider theme={muiTheme}>
      <div className="app" style={{ marginTop: 60 }}>
          <Outlet />
        <div style={{ ...theme.Container.flexCenter, marginTop: 100 }}>
          <a href="https://trubalancebioenergetics.com"><img src={logo} alt="TruBalance Bioenergetics" style={{ height: 160 }} /></a>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default VideoLayout;
